var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-appbar',{attrs:{"back-to":true}},[_vm._v(" Carga Total ")])
}
var staticRenderFns = []

export { render, staticRenderFns }